import type { Item } from './types';

export const PREFIX_LABELS: Record<string, string> = {
  el: 'Email automation',
  af: 'Auto-fulfillment',
  so: 'SendOwl',
  sr: 'Storefront',
  se: 'SEO',
  cl: 'Clarity',
  lc: 'LCP',
  pr: 'Product research',
  hp: 'Homepage',
  obs: 'Observation',
  's-res': 'Research',
  's-lis': 'Listings',
  's-sf': 'Storefront',
  's-perf': 'Performance',
};

export function itemPrefix(id: string | undefined | null): string {
  if (!id) return 'other';
  const m = String(id).match(/^([a-z][a-z0-9]*(?:-[a-z]+)*)-\d+$/i);
  return m ? m[1].toLowerCase() : 'other';
}

export function prefixLabel(prefix: string): string {
  if (PREFIX_LABELS[prefix]) return PREFIX_LABELS[prefix];
  if (prefix === 'other') return 'Other';
  return prefix.toUpperCase();
}

export interface DerivedTaskItem {
  id: string;
  text: string;
  done: boolean;
  blocked: string;
  status: string;
  estimate_minutes: number;
}

export interface DerivedTask {
  id: string;
  title: string;
  isOverview?: boolean;
  items?: DerivedTaskItem[];
}

export function deriveTasksFromItems(items: Item[]): DerivedTask[] {
  const groups: Record<string, Item[]> = {};
  const order: string[] = [];
  for (const it of items) {
    const p = itemPrefix(it.id);
    if (!groups[p]) {
      groups[p] = [];
      order.push(p);
    }
    groups[p].push(it);
  }
  const tasks: DerivedTask[] = [{ id: 'overview', title: 'Overview', isOverview: true }];
  for (const p of order) {
    const groupItems: DerivedTaskItem[] = groups[p].map(it => ({
      id: it.id,
      text: it.label || it.id,
      done: it.status === 'done' || it.status === 'dropped',
      blocked: it.status === 'blocked' ? (it.block_reason || 'blocked') : '',
      status: (it.status || 'open') as string,
      estimate_minutes: it.estimate_minutes || 0,
    }));
    tasks.push({
      id: 'group-' + p,
      title: prefixLabel(p),
      items: groupItems,
    });
  }
  return tasks;
}
